<template>
    <div class="input-group mb-3 w-50">
        <b-form-input
            type="text"
            class="form-control"
            placeholder="enter new session name here (e.g story slug)"
            v-model="sessionName"
        />
        <b-button class="ml-2" variant="primary" @click="createSession">
            Create New Session
        </b-button>
    </div>
</template>

<script>
import api from "@/api";

export default {
    name: "SessionCreate",

    data: () => {
        return {
            sessionName: undefined,
        };
    },

    methods: {
        async createSession() {
            if (!this.validSessionName(this.sessionName)) return;

            let result = await api.sessions.create({ sessionName: this.sessionName });

            let { error, message, results } = result;
            if (error) {
                console.error(message);
                return;
            }

            let { session } = results;
            if (session) this.$emit("created", session);
        },

        validSessionName(str) {
            if (!str) return false;
            if (!str.replace(/\s/g, "").length) return false;
            return true;
        },
    },
};
</script>